export const enum INPUT_TYPES {
    PASSWORD = "password",
    TEXT = "text",
}
